// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings'))
	theme.settings.predictiveSearchEnabled = false;
// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSConfig.custom.products_per_page,
		loadProductFirst: false,
		numberFilterTree: 2,
		filterTreeMobileStyle: 'style1',
		requestInstantly: true,
		enableKeepScrollbackPosition: false,
},
	recentlyViewed: {
		recentlyViewedEnable: true,
		// 		recentProductSliderRange: 4, // Products shown in 1 slide
		limit: 8, // Total number of products
	},
};

(function () {
	var onSale = false,
		soldOut = false,
		priceVaries = false,
		images = [],
		boostPFSRangeWidths = [165, 360, 533, 720, 940, 1066];

	BoostPFS.inject(this);

	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock
		onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Convert images to array
		images = data.images_info;
		// Get First Variant (selected_or_first_available_variant)
		firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function (e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined')
				firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		return data;
	}

	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function (data) {
		if (!data) data = this.data;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);
		var itemHtml;
		var itemHtml = boostPFSTemplate.productGridItemHtml;

		// Add Custom class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		var saleClass = onSale ? boostPFSTemplate.saleClass : '';

		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

		itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

		// Add Card product class
		itemHtml = itemHtml.replace(
			/{{cardProductClass}}/g,
			buildCardProductClass()
		);
		// Add sold out Label
		itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildSoldOutLabel());
		// Add sale Label
		itemHtml = itemHtml.replace(/{{itemSale}}/g, buildSaleLabel());
		// Add Images
		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
		// Add Price
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
		itemHtml = itemHtml.replace(/{{itemAddtocart}}/g, buildAddtocart(data));
		itemHtml = itemHtml.replace(/{{itemMetafield}}/g, buildMetafield(data));
		itemHtml = itemHtml.replace(/{{itemBadges}}/g, buildBadges(data));
		// Add Review
		if (
			typeof Integration === 'undefined' ||
			(typeof Integration != 'undefined' &&
				typeof Integration.hascompileTemplate == 'function' &&
				!Integration.hascompileTemplate('reviews'))
		) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
		}

		// Add Vendor
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
		itemHtml = itemHtml.replace(/{{itemTag}}/g, buildTags(data));
		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(
			/{{itemUrl}}/g,
			Utils.buildProductItemUrl(data)
		);
		itemHtml = itemHtml.replace(
			/{{itemDescription}}/g,
			data.description ? data.description : ''
		);
		itemHtml = itemHtml.replace(/{{itemAddtocart}}/g, data.id);

		return itemHtml;
	};

	/************************** END BUILD PRODUCT LIST **************************/
	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
	function buildImages(data) {
		var itemUrl = Utils.buildProductItemUrl(data);
		var html = '',
			aspectRatio = '',
			rangeWidths = boostPFSRangeWidths,
			paddingBottom = 100;

		var dataSrcSet = '',
			imgAlt = data.title,
			flipImageSrcSet = '';

		var activeSwapImage =
			!Utils.isMobile() &&
			images.length > 1 &&
			boostPFSThemeConfig.custom.hasOwnProperty('show_secondary_image') &&
			boostPFSThemeConfig.custom.show_secondary_image == true;

		for (var i = 0; i < rangeWidths.length; i++) {
			dataSrcSet +=
				Utils.getFeaturedImage(images, rangeWidths[i] + 'x') +
				' ' +
				rangeWidths[i] +
				'w';

			if (activeSwapImage) {
				flipImageSrcSet +=
					Utils.optimizeImage(images[1]['src'], rangeWidths[i] + 'x') +
					' ' +
					rangeWidths[i] +
					'w';
			}

			if (i < rangeWidths.length - 1) {
				dataSrcSet += ', ';

				if (activeSwapImage) {
					flipImageSrcSet += ', ';
				}
			}
		}

		if (images.length > 0) {
			aspectRatio = images[0]['width'] / images[0]['height'];
			paddingBottom = (1 / aspectRatio) * 100;

			html += '<div class="medias';
			if (boostPFSThemeConfig.custom.hasOwnProperty('media_size')) {
				html += boostPFSThemeConfig.custom.media_size;
			}
			html += ' media_product"';
			html += '>';
			html += '<a href="' + itemUrl + '" class="media-product media ">';
			html +=
				'<img class="motion-reduce"' +
				'src="' +
				Utils.optimizeImage(images[0].src, '656x656') +
				'" ' +
				'alt="' +
				imgAlt +
				'" />';
			if (data.media['1'] != null) {
				switch (data.media['1'].mediaContentType) {
					case 'IMAGE':
						let tmpImage = Array();
						tmpImage.push(images[1]);
						html +=
							'<img class="motion-reduce"' +
							'src="' +
							Utils.getFeaturedImage(tmpImage, '656x656') +
							'" ' +
							'alt="' +
							imgAlt +
							'" />';
						break;
					case 'EXTERNAL_VIDEO':
						if (data.media['1'].embeddedUrl.includes('youtu.be')) {
							data.media['1'].embeddedUrl = data.media['1'].embeddedUrl.replace(
								'youtu.be',
								'youtube.com/embed'
							);
						}
						html += '<div class="video-card">';
						html +=
							'<iframe frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"';
						html +=
							'allowfullscreen="allowfullscreen" src="' +
							data.media['1'].embeddedUrl +
							'?autoplay=1" title="' +
							data.title +
							'"></iframe>';
						html += '</div>';
						break;
					case 'VIDEO':
						html += '<div class="video-card">';
						html +=
							'<video playsinline="playsinline" preload="metadata" aria-label="' +
							data.title +
							'" muted>';
						html +=
							'<source src="' +
							data.media['1'].sources['0'].url +
							'" type="video/mp4"></video>';
						html += '</div>';
						break;
				}
			}

			html += '</a>';
			html += '</div>';
		} else {
			html +=
				'<div class="mediaportrait media-product media"><img src="https://cdn.shopify.com/s/files/1/0591/6563/8808/files/place-holder.png" /></div>';
		}
		return html;
	}

	function buildCardProductClass() {
		var html = '';
		if (!images || (images && images.length === 0)) {
			html = 'card--outline';
		} else {
			html = 'card--outline';
		}
		return html;
	}

	function buildAddtocart(data) {
		let tags = data.tags;
		let id = data.variants[0].id;
		let data_template_suffix = data.template_suffix;
		let data_handle = data.handle;
		const colours = data.options_with_values
			.filter((option) => option.name === 'colour')
			.map((option) => option.values)
			.flat();
		let hexData = ''
		if(data.metafields.length > 0){
			hexData = data.metafields.filter((metafield)=> metafield.key === "hex_color")
			if(hexData.length > 0) {
				hexData = JSON.parse(hexData[0].value)
			}
		}

		var html = '';
		if (
			typeof tags != 'undefined' &&
			tags != null &&
			tags.length != null &&
			tags.length > 0
		) {
			for (const value of tags) {
				let valueCase = value.toLowerCase();
				if (valueCase == 'au-stockists' || valueCase == 'non-purchase') {
					return html;
				}
			}
		}

		if (data_template_suffix == 'gift_card') {
			html = `<a href='/products/${data_handle}' class="btn btn-hollow btn-full btn_products" data-id =${id}>${window.product.add_to_cart}</a>`;
		}

		if(data.available) {
			if (!data.options_with_values.find((option) => option.name === 'colour') && !data.options_with_values.find((option) => option.name === 'size')) {
				html = `<div class="btn btn-hollow btn-full btn-add-to-cart" data-id="${id}">${window.product.add_to_cart}</div>`;
			} else {
				let optionsHtml = '';

				for (const option of data.options_with_values) {
					let valuesHtml = ``;

					for (const value in option.values) {
						let isSelected = value===0?'selected="selected"':'';
						valuesHtml += `
						<option value="${option.values[value].title}" data-color="${hexData[option.values[value].title]}" ${isSelected}>${option.values[value].title}</option>
					`;
					}

					optionsHtml += `
					<fieldset class="js product-form__input">
						<legend class="form__label">${option.name}</legend>
						${valuesHtml}
					</fieldset>
				`;
				}
				var variantJson = JSON.stringify(data.variants);
				html = `<variant-selects class="no-js-hidden" data-url="/products/${data.handle}">
				<div class="product-form__input product-form__input--dropdown">
					<div class="select show_custom_select">
						<select id="product-form-template" colour="" data-variant-selector="" data-is-custom="true" class="select__select has-value" placeholder=" " name="options[Colour]" form="product-form-template">
							${optionsHtml}
						</select>
					</div>
				</div>
				<script type="application/json">
					${variantJson}
				</script
			</variant-selects>
			<div name="add" class="btn btn-hollow btn-add-to-cart" data-id=${id}>${window.product.add_to_cart}</div>
			`;
			}
		}else {
			html = `<button type="submit" name="add" class="product-form__submit button button--full-width button--secondary" disabled=""><span class="btn-text">Sold out</span><span class="icon-loading icon-svg">
                            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
</svg>
                          </span>
                      </button>`
		}

		return html;
	}
	function isJsonString(str) {
		if (!str) return false;
		try {
			JSON.parse(str);
		} catch (e) {
			return false;
		}
		return true;
	}
	function buildMetafield(data) {
		var html = '';
		if (data.metafields.length > 0) {
			var desMeta = data.metafields.find(e => e.namespace == 'info' && e.key == 'short_text');
			var desColMeta = data.metafields.find(e => e.key == 'short_text_collection');
			try {
				html = isJsonString(desColMeta?.value) ? JSON.parse(desColMeta.value)[0] : desColMeta.value
			} catch (err) {
				console.warn('could not parse desColMeta', desColMeta)
			}

			if (html) return html

			try {
				html = isJsonString(desMeta?.value) ? JSON.parse(desMeta.value)[0] : desMeta.value
			} catch (err) {
				console.warn('could not parse desMeta', desMeta)
			}
		}
		return html;
	}
	function buildBadges(data) {
		var html = '';
		if (data.metafields.length > 0) {
			const badgesData = data.metafields.filter((metafield)=> metafield.key === "image_overlay")
			if (badgesData.length > 0) {
				let badges_arr = JSON.parse(badgesData[0].value);
				if (badges_arr.length > 0) {
					html = '<div class="image-overlay">';
					badges_arr.forEach(function (badges) {
						html +=
							'<img src="' + badges.src + '" alt="' + badges.alt + '" ></img>';
					});
					html += '</div>';
				}
			}
		}
		return html;
	}

	function buildVendor(data) {
		var html = '';
		if (
			boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') &&
			boostPFSThemeConfig.custom.show_vendor === true
		) {
			html = boostPFSTemplate.vendorHtml;
		}
		return html;
	}

	function buildTags(data) {
		let tags = data.tags;
		var html = '';
		if (
			typeof tags != 'undefined' &&
			tags != null &&
			tags.length != null &&
			tags.length > 0
		) {
			for (const value of tags) {
				if (value == 'Bestseller') {
					html = `<div class="card__badge"><span class="badge badge--bottom-left color-accent-2">Bestseller</span></div>`;
				} else if (value == 'New') {
					html = `<div class="card__badge"><span class="badge badge--bottom-left color-accent-2">New</span></div>`;
				}
				return html;
			}
		} else {
			return html;
		}
	}

	function buildPrice(data) {
		var html = '';
		let tags = data.tags;
		if (
			typeof tags != 'undefined' &&
			tags != null &&
			tags.length != null &&
			tags.length > 0
		) {
			for (const value of tags) {
				let valueCase = value.toLowerCase();
				if (valueCase == 'au-stockists') {
					return html;
				}
			}
		}

		var noComparePrice =
			data.price_varies === false && data.compare_at_price_varies;
		var moneyPrice = priceVaries
			? boostPFSConfig.label.from_price_html.replace(
					/{{ price }}/,
					Utils.formatMoney(data.price_min)
			  )
			: Utils.formatMoney(data.price_min);
		var unitPriceClass =
			!data.available ||
			typeof data?.selected_or_first_available_variant
				?.unit_price_measurement === 'undefined'
				? 'hidden'
				: '';
		html = `<div class="price ${soldOut ? 'price--sold-out' : ''} ${
			onSale ? 'price--on-sale' : ''
		}${noComparePrice ? 'price--no-compare' : ''}"
					<dl>
						<div class="price__regular">
							<dt>
								<span class="visually-hidden visually-hidden--inline">
									${boostPFSConfig.label.regular_price}
								</span>
							</dt>
							<dd>
								<span class="price-item price-item--regular">
									${moneyPrice}
						  		</span>
							</dd>
						</div>
						<div class="price__sale">
							<dt class="price__compare">
								<span class="visually-hidden visually-hidden--inline">
									${Utils.formatMoney(data.sale_price)}
								</span>
							</dt>
							<dd class="price__compare">
								<s class="price-item price-item--regular">
								${Utils.formatMoney(data.compare_at_price_min)}
								</s>
						  	</dd>
							<dt>
							  <span class="visually-hidden visually-hidden--inline">${
									boostPFSConfig.label.sale_price
								}</span>
							</dt>
							<dd class="price__last">
								<span class="price-item price-item--sale">
									${moneyPrice}
								</span>
						  	</dd>
						</div>
						<small class="unit-price caption ${unitPriceClass}">
							<dt class="visually-hidden">${boostPFSConfig.label.unit_price}</dt>
							<dd class="price__last">
								<span>${Utils.formatMoney(
									data.selected_or_first_available_variant &&
										data.selected_or_first_available_variant.unit_price
								)}</span>
								<span aria-hidden="true">/</span>
								<span class="visually-hidden">&nbsp;${
									boostPFSConfig.label.unit_price_separator
								}&nbsp;</span>
							</dd>
					  </small>
					</dl>
				</div>`;
		return html;
	}

	function buildSoldOutLabel() {
		// Build Sold out label
		var soldOutLabel = '';
		if (
			boostPFSThemeConfig.custom.hasOwnProperty(
				'sold_out_badge_color_scheme'
			) &&
			soldOut
		) {
			soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(
				/{{soldOutBadgeClass}}/g,
				boostPFSThemeConfig.custom.sold_out_badge_color_scheme
			);
		}
		return soldOutLabel;
	}

	function buildSaleLabel() {
		// Build Sale label
		var saleLabel = '';
		if (
			boostPFSThemeConfig.custom.hasOwnProperty('sale_badge_color_scheme') &&
			onSale &&
			!soldOut
		) {
			saleLabel = boostPFSTemplate.saleLabelHtml.replace(
				/{{saleBadgeClass}}/g,
				boostPFSThemeConfig.custom.sale_badge_color_scheme
			);
		}
		return saleLabel;
	}

	function buildReview(data) {
		var html = '';
		if (
			boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
			boostPFSThemeConfig.custom.show_product_review == true &&
			Utils.getProductMetafield(data, 'reviews', 'rating') !== null
		) {
			var ratingObj = JSON.parse(
				Utils.getProductMetafield(data, 'reviews', 'rating')
			);
			var rating_decimal = 0;
			var decimal = parseFloat(ratingObj.value.rating);
			if (decimal >= 0.3 && decimal <= 0.7) {
				rating_decimal = 0.5;
			} else if (decimal > 0.7) {
				rating_decimal = 1;
			}
			html = `<div class="rating" role="img" aria-label="${boostPFSConfig.label.star_reviews_info
				.replace('{{ rating_value }}', ratingObj.value)
				.replace('{{ rating_max }}', ratingObj.value.scale_max)}">
                <span aria-hidden="true" class="rating-star color-icon-${
									boostPFSConfig.custom.accent_icons
								}" style="--rating: ${Math.round(
				ratingObj.value.rating
			)}; --rating-max: ${
				ratingObj.value.scale_max
			}; --rating-decimal: ${rating_decimal};"></span>
              </div>
              <p class="rating-text caption">
                <span aria-hidden="true">${ratingObj.value} / ${
				ratingObj.value.scale_max
			}</span>
              </p>
              <p class="rating-count caption">
                <span aria-hidden="true">(${Utils.getProductMetafield(
									data,
									'reviews',
									'rating_count'
								)})</span>
                <span class="visually-hidden">${Utils.getProductMetafield(
									data,
									'reviews',
									'rating_count'
								)} ${boostPFSConfig.label.total_reviews}</span>
              </p>`;
		}
		return html;
	}

	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;
		// Build Previous
		var previousHtml =
			currentPage > 1 ? boostPFSTemplate.previousActiveHtml : '';
		previousHtml = previousHtml.replace(
			/{{itemUrl}}/g,
			Utils.buildToolbarLink('page', currentPage, currentPage - 1)
		);
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		// Build Next
		var nextHtml =
			currentPage < totalPage ? boostPFSTemplate.nextActiveHtml : '';
		nextHtml = nextHtml.replace(
			/{{itemUrl}}/g,
			Utils.buildToolbarLink('page', currentPage, currentPage + 1)
		);
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		// Create page items array
		var beforeCurrentPageArr = [];
		for (
			var iBefore = currentPage - 1;
			iBefore > currentPage - 3 && iBefore > 0;
			iBefore--
		) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);
		var afterCurrentPageArr = [];
		for (
			var iAfter = currentPage + 1;
			iAfter < currentPage + 3 && iAfter <= totalPage;
			iAfter++
		) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}
		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml +=
					pageArr[iPage] == currentPage
						? boostPFSTemplate.pageItemSelectedHtml
						: boostPFSTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(
				/{{itemUrl}}/g,
				Utils.buildToolbarLink('page', currentPage, pageArr[iPage])
			);
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		return paginationHtml;
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function () {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				var paramSort = Globals.queryParams.sort || '';
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml +=
						'<li><a href="#" data-sort="' +
						k +
						'">' +
						sortingArr[k] +
						'</a></li>';
				}
				html = boostPFSTemplate.sortingHtml.replace(
					/{{sortingItems}}/g,
					sortingItemsHtml
				);
			}
		}
		return html;
	};

	ProductSorting.prototype.render = function () {
		jQ(Selector.topSorting).html(this.compileTemplate());

		if (
			jQ('.boost-pfs-filter-custom-sorting').hasClass(
				'boost-pfs-filter-sort-active'
			)
		) {
			jQ('.boost-pfs-filter-custom-sorting').toggleClass(
				'boost-pfs-filter-sort-active'
			);
		}

		var labelSort = '';
		var paramSort = Globals.queryParams.sort || '';
		var sortingList = Utils.getSortingList();
		if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
			labelSort = sortingList[paramSort];
		} else {
			labelSort = Labels.sorting_heading;
		}

		jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
	};

	// Build Sorting event
	ProductSorting.prototype.bindEvents = function () {
		jQ('.boost-pfs-filter-filter-dropdown li a').click(function (e) {
			e.preventDefault();
			FilterApi.setParam('sort', jQ(this).data('sort'));
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
		});

		jQ('.boost-title-dropdown').click(function () {
			jQ('.boost-pfs-filter-top-sorting').toggleClass(
				'boost-pfs-filter-sort-active'
			);
		});

		$(document).on('click', function (e) {
			var container = $('.boost-title-dropdown');
			var container2 = $('.boost-pfs-filter-filter-dropdown');
			if (
				!container.is(e.target) &&
				container.has(e.target).length === 0 &&
				!container2.is(e.target) &&
				container2.has(e.target).length === 0
			) {
				jQ('.boost-pfs-filter-top-sorting').removeClass(
					'boost-pfs-filter-sort-active'
				);
			}
		});
	};

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function (data) {
		if (!data) data = this.data;
		//Adding banners via ajax to stop conflict with otp buttons
		if (Globals.queryParams.page === 1) {
			var bannersHtml = '<div class="collection_hero_title" data-page="1">';
			bannersHtml += '<div class="collection-wrapper">';
			bannersHtml += '<h1>' + boostPFSConfig.custom.collection_title + '</h1>';
			bannersHtml +=
				'<span>' + boostPFSConfig.custom.collection_description + '</span>';
			bannersHtml += '</div></div>';
			jQ(Selector.products).prepend(bannersHtml);
		}
		setTimeout(function () {
			if ($('.card-wrapper').length > 0) {
				$('.card-wrapper').removeClass('card-wrapper--skeleton');
			}
		}, 2000);
		// play video
		$('.card-wrapper')
			.find('.video-card')
			.each(function () {
				var target = $(this);
				if (target.find('video').length > 0) {
					let video = target.find('video');
					$(video).attr('muted', true);
					$(video)[0].addEventListener('mouseover', function () {
						this.play();
					});

					$(video)[0].addEventListener('mouseout', function () {
						this.pause();
					});

					$(video)[0].addEventListener('touchstart', function () {
						this.play();
					});

					$(video)[0].addEventListener('touchend', function () {
						this.pause();
					});
				}
				if (target.find('iframe').length > 0) {
					let iframe = target.find('iframe');
					let url = new URL($(iframe).attr('src'));
					$(iframe)
						.mouseenter(function () {
							url.searchParams.append('autoplay', 1);
							url.searchParams.append('mute', 1);
							$(iframe).attr('src', url.href);
						})
						.mouseleave(function () {
							url.searchParams.delete('autoplay');
							$(iframe).attr('src', url.href);
						});
				}
			});
	};

	// Build Additional Elements
	Filter.prototype.afterRender = function (data, eventType) {
		if (!data) data = this.data;
		jQ('.boost-pfs-filter-total-product').html(
			data.total_product + ' products'
		);
		jQ('select.select__select option:first-child').remove();


		jQ('.boost-pfs-filter-wrapper variant-selects').each(function(){
			this.removeEventListener('change', this.onVariantChange);
			this.addEventListener('change', function() {
				this.updateOptions();
				this.updateMasterId();
				this.toggleAddButton(true, '', false);
				this.updatePickupAvailability();
				this.removeErrorMessage();

				const input = this.querySelectorAll('.btn-add-to-cart[name="add"]');

				if (!this.currentVariant) {
					this.currentVariant = this.getVariantData()[0];
				}
				input.forEach(function(btnAddToCart){
					jQuery(btnAddToCart).data('id', this.currentVariant.id);
				}.bind(this));

			}.bind(this));
		});
	};

	/** Check item count and aplly count */
	jQ(document).on('click', '.boost-pfs-filter-option-item', function () {
		setTimeout(function () {
			var count = jQ(
				'.boost-pfs-filter-refine-by-items .refine-by-item'
			).length;
			if (count == 0) {
				jQ('.filter_title .count').html('');
			} else {
				jQ('.filter_title .count').html('(' + count + ')');
			}
		}, 3000);
	});
	/** Check item count and render count */
	jQ(document).on(
		'click',
		'.boost-pfs-filter-clear, .boost-pfs-filter-clear-all',
		function () {
			setTimeout(function () {
				var count = jQ(
					'.boost-pfs-filter-refine-by-items .refine-by-item'
				).length;
				if (count == 0) {
					jQ('.filter_title .count').html('');
				} else {
					jQ('.filter_title .count').html('(' + count + ')');
				}
			}, 3000);
		}
	);
	/** Check item count filter */
	setTimeout(function () {
		var count = jQ('.boost-pfs-filter-refine-by-items .refine-by-item').length;
		if (count == 0) {
			jQ('.filter_title .count').html('');
		} else {
			jQ('.filter_title .count').html('(' + count + ')');
		}

		var countItem = jQ(
			'.boost-pfs-filter-options-wrapper .boost-pfs-filter-option'
		).length;
		if (countItem == 0) {
			jQ('.filter_title').html('');
		}
	}, 3000);
	/** Click open filter */
	jQ(document).on('click', '.filter_title', function () {
		jQ('.boost-pfs-filter-left-col').addClass('active');
		jQ('.bg_filter').addClass('active');
		jQ('html').addClass('open_filter');
	});

	/** Click close filter */
	jQ(document).on('click', '.bg_filter,.closer_filter', function () {
		jQ('.bg_filter').removeClass('active');
		jQ('.boost-pfs-filter-left-col').removeClass('active');
		jQ('html').removeClass('open_filter');
	});

	FilterOptionItemMultiLevelCollections.prototype.init = function () {
		var selectType = this.filterOption
			? this.filterOption.selectType
			: this.parent.selectType;
		this.requestInstantly = Settings.getSettingValue(
			'general.requestInstantly'
		);
	};

	FilterApplyButton.prototype.init = function () {
		this.label = Settings.getSettingValue('general.requestInstantly')
			? Labels.close
			: Labels.apply;
	};

	FilterOptionItemMultiLevelTag.prototype.init = function () {
		var selectType = this.filterOption
			? this.filterOption.selectType
			: this.parent.selectType;
		this.requestInstantly =
			this.filterTreeType == FilterTreeEnum.FilterTreeType.VERTICAL ||
			Settings.getSettingValue('general.requestInstantly');
	};

	FilterOptionItem.prototype.init = function () {
		this.requestInstantly = Settings.getSettingValue(
			'general.requestInstantly'
		);
	};

	FilterOptionRangeSlider.prototype.onFinishDragging = function () {
		// Set selected filter items
		if (this.isNumberRangeSlider) {
			this.filterItems.forEach((filterItem) => {
				filterItem.setValue(this.currentMin, this.currentMax);
			});
		} else {
			// Can't filterItems.foreach and compare index because it's a map.
			// So we pick out the selected values in another array.
			var selectedValues = [];
			if (
				this.currentMin != this.rangeMin ||
				this.currentMax != this.rangeMax
			) {
				for (var i = this.currentMin; i <= this.currentMax - 1; i++) {
					selectedValues.push(this.valuesData[i].key);
				}
			}

			this.filterItems.forEach((filterItem) => {
				filterItem.isSelected = selectedValues.includes(filterItem.value);
			});
		}

		// Perform API request
		if (Settings.getSettingValue('general.requestInstantly')) {
			var filterValues = [];
			this.filterItems.forEach((filterItem) => {
				if (filterItem.isSelected) {
					filterValues.push(filterItem.value);
				}
			});

			FilterApi.setParam(this.filterOptionId, filterValues);
			FilterApi.setParam('page', 1);

			var eventType = 'filter';
			var eventInfo = {
				filterOptionId: this.filterOptionId,
				filterOptionValue: filterValues,
			};
			FilterApi.applyFilter(eventType, eventInfo);
		}
	};

	FilterRefineBy.prototype.getTemplate = function () {
		var customCloseDiv = Utils.checkExistFilterOptionParam()
			? '<div class="close_filter"></div>'
			: '';
		switch (this.filterTreeType) {
			case FilterTreeEnum.FilterTreeType.VERTICAL:
				return `
					<div class="{{class.filterRefineBy}}">
						<div class="{{class.filterOptionTitle}}">
							<div class="{{class.filterOptionTitle}}-heading" role="heading" aria-level="2"><span>{{label}}</span></div>
							{{clearAllButton}}
						</div>
						<div class="{{class.filterSelectedItems}}">{{refineByItems}}</div>
					</div>
				`.trim();
			case FilterTreeEnum.FilterTreeType.HORIZONTAL:
				return `
					<div class="boost-pfs-filter-pc {{class.filterRefineBy}}">
						<span>{{label}}</span>
						<div class="{{class.filterSelectedItems}}">{{refineByItems}}</div>
						{{clearAllButton}}
					</div>
				`.trim();
			default:
				throw Error('Wrong filterTreeType');
		}
	};

	BoostOTP.inject(this);
	boostPFSFilterConfig.recentlyViewed.recentProductSliderRange =
		Utils.isMobile() ? '2' : '4';
	/************************** END BUILD TOOLBAR **************************/

	/* start-boost-custom */
	jQ(document).on('click', '.boost-pfs-filter-show-result', function () {
		jQ('.boost-pfs-filter-left-col,.bg_filter').removeClass('active');
		jQ('html').removeClass('open_filter');
	});
	/* end-boost-custom */

  /* start-boost-custom 145588 */
  Filter.prototype.errorFilterCallback = function(){
    if (!Utils.isiOS()
				&& !Utils.isSafari()
				&& !Utils.isBackButton()
				&& !Utils.getWindowLocation().href.includes('view=boost-pfs-original')) {
			var newUrl = boostPFSAppConfig.shop.url;
			if (!Utils.isBadUrl(newUrl)) {
				window.location.href = newUrl;
			}
		}
  }
  /* start-boost-custom 145588 */
})();
